module.exports = __webpack_public_path__ + "static/trainer4-1da6d244be71215df03d836e9b53ccad.png";